import { Injectable } from '@angular/core';
import { hideLoader } from '@app/core/interceptors/interceptor-http-params';
import { GraphqlService } from '@app/core/services/graphql.service';
import {
  copyActivityTypesMutation,
  deleteActivityTypesMutation,
  saveActivityTypeMutation
} from '@app/pcs/data/activity-type.mutations';
import {
  activityTypeQuery,
  activityTypesSearchQuery,
  activityTypesWithEditRulesQuery,
  validateActivityTypeCodeQuery
} from '@app/pcs/data/activity-type.queries';
import { PcsEntity } from '@app/pcs/models';
import { ActivityType } from '@app/pcs/models/activity-type';
import { ReferenceDataSearchContext } from '@app/pcs/models/reference-data-search-context';
import { ReferenceDataSearchType } from '@app/pcs/models/reference-data-search-type';
import { UserGridType } from '@app/pcs/models/user-grid-type';
import { safeProp } from '@util';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class ActivityTypeDataService {

  constructor(private graphqlService: GraphqlService) {
  }

  fetch(context: ReferenceDataSearchContext) {
    return this.graphqlService.query(activityTypesSearchQuery, {
      searchContext: {
        ...context,
        type: {id: PcsEntity.ActivityType},
        searchType: {id: ReferenceDataSearchType.Dossier}
      }
    }, hideLoader());
  }

  fetchWithEditRules(ttpId, imAgencyId) {
    return this.graphqlService.query(activityTypesWithEditRulesQuery, {
      searchContext: {
        ttpId,
        imAgencyId,
        type: {id: PcsEntity.ActivityType},
        searchType: {id: ReferenceDataSearchType.Administration}
      },
      userGridType: {id: UserGridType.ActivityTypes}
    }).pipe(map((response) => ({
      activityTypes: response[0], referenceDataEditRules: response[1], userGridConfiguration: response[2]
    })));
  }

  fetchById(id: number): Observable<ActivityType> {
    return this.graphqlService.query(activityTypeQuery, {
      id
    });
  }

  validateActivityTypeCode(activityType: Partial<ActivityType>): Observable<boolean> {
    return this.graphqlService.query(validateActivityTypeCodeQuery, {
      input: {
        activityTypeId: activityType.id,
        ttpId: activityType.ttpId,
        agencyId: safeProp('id', activityType.agency),
        value: activityType.code
      }
    }, hideLoader());
  }

  copy(activityTypeIds: number[], ttpId: number) {
    return this.graphqlService.mutation(copyActivityTypesMutation, {
      activityTypeIds,
      ttpId
    });
  }

  delete(activityTypeIds: number[]) {
    return this.graphqlService.mutation(deleteActivityTypesMutation, {
      activityTypeIds
    });
  }

  save(activityType: ActivityType) {
    return this.graphqlService.mutation(saveActivityTypeMutation, {
      activityType
    });
  }

}
